<template>
  <v-content>
    <v-container fluid>
      <Header :title="'Modules'" />
      <Tutor :buttonName="'Book a Tutor'" v-if="has_tutor_products"/>
      <v-row>
        <v-container @keyup.enter="searchQuery" fluid>
          <v-row>
            <v-col cols="12" md="8" sm="12">
              <v-text-field
                outlined
                v-model="search"
                name="search"
                :placeholder="'Module name here' | translate"
                required
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="2" sm="12">
              <v-btn
                small
                :color="primary_color"
                class="white--text"
                @click="searchQuery"
                x-large
                block
              >
                <v-icon>mdi-search</v-icon>{{ "Search" | translate }}
              </v-btn>
            </v-col>
            <v-col cols="12" md="2" sm="12">
              <v-menu
                offset-y
                :close-on-content-click="false"
                bottom
                origin="center center"
                transition="scale-transition"
              >
                <template v-slot:activator="{ on }">
                  <v-btn small v-on="on" x-large block>
                    <v-icon>mdi-filter</v-icon>{{ "Filters" | translate }}
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item>
                    <v-list-item-title>
                      <template>
                        <v-expansion-panels
                          accordion
                          v-for="(item, index) in filters"
                          :key="index"
                        >
                          <v-expansion-panel>
                            <v-expansion-panel-header>{{
                              item.text | translate
                            }}</v-expansion-panel-header>
                            <v-expansion-panel-content
                              v-if="item.text == 'Language'"
                            >
                              <v-checkbox
                                v-model="lang_ids"
                                :id="'id' + labeldata.text + indexnumber"
                                :label="labeldata.text | translate"
                                :value="labeldata.value"
                                @change="send"
                                v-for="(labeldata, indexnumber) in item.flags"
                                :key="indexnumber"
                              ></v-checkbox>
                            </v-expansion-panel-content>
                            <v-expansion-panel-content
                              v-if="item.text == 'Subscription'"
                            >
                              <v-checkbox
                                v-model="subscriptions"
                                :id="'id' + labeldata.text + indexnumber"
                                :label="labeldata.text | translate"
                                :value="labeldata.value"
                                @change="send"
                                v-for="(labeldata, indexnumber) in item.flags"
                                :key="indexnumber"
                              ></v-checkbox>
                            </v-expansion-panel-content>
                            <v-expansion-panel-content
                              v-if="item.text == 'Course'"
                            >
                              <v-checkbox
                                v-model="coursesData"
                                :id="'id' + labeldata.text + indexnumber"
                                :label="labeldata.text | translate"
                                :value="labeldata.value"
                                @change="send"
                                v-for="(labeldata, indexnumber) in coursevalues"
                                :key="indexnumber"
                              ></v-checkbox>
                            </v-expansion-panel-content>
                          </v-expansion-panel>
                        </v-expansion-panels>
                      </template>
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-col>
          </v-row>

          <v-row v-if="selectedFilters.length > 0">
            <v-col cols="12">
              <p class="headline">{{ "Filters" | translate }}</p>
              <v-chip
                class="ma-2"
                :color="primary_color"
                @click:close="removeFilter(filters)"
                label
                close
                v-for="(filters, index) in selectedFilters"
                :key="index"
              >
                {{
                  filters.hasOwnProperty("lang_name")
                    ? filters.lang_name
                    : filters.hasOwnProperty("course_name")
                    ? filters.course_name
                    : filters.text | translate
                }}
              </v-chip>
            </v-col>
          </v-row>
        </v-container>
        <v-container v-if="modules.length > 0 && loadingdata == false" fluid>
          <v-layout row wrap>
            <v-flex
              :class="
                $store.state.globals.mini
                  ? 'md4 sm6 xs-12 mb-5'
                  : 'md6 sm12 xs-12 mb-5'
              "
              v-for="datas in modules"
              :key="datas.modules_id"
            >
              <v-card class="ma-2 mt-n1" height="100%">
                <v-card-title class="headline course-title">
                  {{ datas.title }}
                </v-card-title>

                <v-img
                  :src="storage_url + datas.thumbnail"
                  height="194"
                ></v-img>
                <v-list-item class="grow">
                  <v-list-item-avatar color="grey darken-3">
                    <v-img
                      class="elevation-6"
                      :src="
                        storage_url +
                        (datas.authors.length > 0
                          ? datas.authors[0].author_pic
                          : '')
                      "
                    ></v-img>
                  </v-list-item-avatar>

                  <v-list-item-content>
                    <v-list-item-title
                      >{{
                        datas.authors.length > 0
                          ? datas.authors[0].hasOwnProperty("author_name")
                            ? datas.authors[0].author_name
                            : ""
                          : ""
                      }}
                      <v-tooltip
                        v-if="
                          datas.authors.length > 1 &&
                          datas.authors[0].hasOwnProperty('author_name')
                        "
                        bottom
                      >
                        <template v-slot:activator="{ on }">
                          <span v-on="on" class="blue--text">{{
                            "& others" | translate
                          }}</span>
                        </template>
                        <p
                          v-for="(authors, index) in datas.authors"
                          :key="authors.author_id"
                        >
                          <span v-if="index !== 0"
                            ><v-avatar
                              ><img
                                :src="storage_url + authors.author_pic"
                                :alt="authors.author_name" /></v-avatar
                            ><span>{{ authors.author_name }}</span></span
                          >
                        </p>
                      </v-tooltip>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-card-text :style="{ height: cardtextHeight }">
                  <v-chip
                    class="mb-2"
                    style="cursor: pointer"
                    @click="addFilter(datas.courses[0])"
                  >
                    {{ datas.courses[0].course_name }}
                  </v-chip>
                  <v-menu open-on-hover bottom offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-chip
                        class="mb-2"
                        style="cursor: pointer"
                        v-if="datas.courses.length > 1"
                        v-on="on"
                        v-bind="attrs"
                        >& view others</v-chip
                      >
                    </template>

                    <v-list>
                      <template v-for="(coursesdata, index) in datas.courses">
                        <v-list-item
                          @click="addFilter(coursesdata)"
                          :key="index"
                          v-if="index != 0"
                        >
                          <v-list-item-title>{{
                            coursesdata.course_name
                          }}</v-list-item-title>
                        </v-list-item>
                      </template>
                    </v-list>
                  </v-menu>

                  <br />
                  <v-chip
                    style="cursor: pointer"
                    class="mb-2"
                    @click="addFilter(datas.language)"
                    >{{ datas.language.lang_name | translate }}</v-chip
                  >

                  <p>
                    {{ datas.description | readMore(255, "...") | stripeHTML }}
                  </p>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions class="mt-1">
                  <v-spacer></v-spacer>
                  <v-btn
                    class="white--text"
                    :color="primary_color"
                    small
                    @click="moduleDetails(datas.module_id)"
                    >{{ "Details" | translate }}</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
        <v-container
          v-else-if="
            modules.length == 0 && routerenter == false && loadingdata == false
          "
          fill-height
          fluid
        >
          <v-row align="center" justify="center">
            <v-col
              ><h2>{{ "No modules found" | translate }}</h2></v-col
            >
          </v-row>
        </v-container>
      </v-row>
    </v-container>
  </v-content>
</template>

<script>
import { mapGetters } from "vuex";
import store from "@/store";
import {
  FETCH_COURSES,
  FETCH_MODULES,
  FETCH_LANGUAGES,
  RESET_STATE,
} from "@/store/actions.type";
import { SET_LOADING, SET_ROUTER_ENTER } from "@/store/mutations.type";

export default {
  name: "Modules",
  beforeRouteEnter(to, from, next) {
    Promise.all([
      store.dispatch(RESET_STATE),
      store.dispatch(FETCH_COURSES, ""),
      store.dispatch(FETCH_LANGUAGES, ""),
      store.dispatch(FETCH_MODULES, ""),
    ]).then(() => {
      store.commit(SET_LOADING, false);
      store.commit(SET_ROUTER_ENTER, false);
    });
    return next();
  },
  components: {
    Header: () => import("@/components/header/Header"),
    Tutor: () => import("@/components/modal/Tutor")
  },
  computed: {
    ...mapGetters([
      "courses",
      "currentUser",
      "mini",
      "modules",
      "languages",
      "loadingdata",
      "routerenter",
    ]),

    coursevalues: function () {
      return this.courses.map(function (obj) {
        return {
          text: obj.course_name,
          value: obj.course_id,
          coursevalue: "courses",
        };
      });
    },
  },
  data: () => ({
    filters: [],
    selectedFilters: [],
    search: "",
    storage_url: "",
    subscriptionData: [
      {
        text: "Subscribed",
        value: "true",
        modelvalue: "subscriptions",
      },
      {
        text: "Unsubscribed",
        value: "false",
        modelvalue: "subscriptions",
      },
    ],
    lang_ids: [],
    subscriptions: [],
    coursesData: [],
    moduleData: null,
    cardtextHeight: 0,
    primary_color: "",
    has_tutor_products:false,
  }),
  beforeDestroy() {
    if (typeof window !== "undefined") {
      window.removeEventListener("resize", this.onResize, { passive: true });
    }
  },
  mounted() {
    this.onResize();
    let company_meta = JSON.parse(this.currentUser.company.company_meta);
    this.primary_color = company_meta.primary_color;

    window.addEventListener("resize", this.onResize, { passive: true });

    if(company_meta.hasOwnProperty('has_tutor_products')){
      this.has_tutor_products = (company_meta.has_tutor_products==='true')
    }
  },
  created() {
    this.storage_url = process.env.VUE_APP_STORAGE_URL;

    let languagedata = this.languages.map(function (obj) {
      return {
        text: obj.lang_name,
        value: obj.lang_id,
        modelvalue: "languages",
      };
    });

    this.filters = [
      {
        text: "Subscription",
        flags: this.subscriptionData,
      },
      {
        text: "Language",
        flags: languagedata,
      },
      {
        text: "Course",
        flags: this.coursevalues,
      },
    ];
  },
  methods: {
    onResize() {
      if (window.innerWidth >= 1565) {
        this.mini
          ? (this.cardtextHeight = "185px")
          : (this.cardtextHeight = "180px");
      } else if (window.innerWidth < 1565 && window.innerWidth >= 1550) {
        this.mini
          ? (this.cardtextHeight = "180px")
          : (this.cardtextHeight = "180px");
      } else if (window.innerWidth < 1550 && window.innerWidth >= 1521) {
        this.mini
          ? (this.cardtextHeight = "180px")
          : (this.cardtextHeight = "170px");
      } else if (window.innerWidth < 1521 && window.innerWidth >= 1371) {
        this.mini
          ? (this.cardtextHeight = "190px")
          : (this.cardtextHeight = "180px");
      } else if (window.innerWidth < 1371 && window.innerWidth >= 1210) {
        this.mini
          ? (this.cardtextHeight = "210px")
          : (this.cardtextHeight = "190px");
      } else if (window.innerWidth < 1210 && window.innerWidth >= 1191) {
        this.mini
          ? (this.cardtextHeight = "200px")
          : (this.cardtextHeight = "180px");
      } else if (window.innerWidth < 1191 && window.innerWidth >= 1143) {
        this.mini
          ? (this.cardtextHeight = "220px")
          : (this.cardtextHeight = "180px");
      } else if (
        window.innerWidth < 1143 &&
        window.innerWidth >= 1110 &&
        this.mini == false
      ) {
        this.cardtextHeight = "215px";
      } else if (window.innerWidth < 1143 && window.innerWidth >= 964) {
        this.mini
          ? (this.cardtextHeight = "240px")
          : (this.cardtextHeight = "210px");
      } else if (
        window.innerWidth < 964 &&
        window.innerWidth >= 959 &&
        this.mini == false
      ) {
        this.cardtextHeight = "220px";
      } else if (window.innerWidth < 964 && window.innerWidth >= 803) {
        this.mini
          ? (this.cardtextHeight = "210px")
          : (this.cardtextHeight = "170px");
      } else if (window.innerWidth < 803 && window.innerWidth >= 726) {
        this.mini
          ? (this.cardtextHeight = "215px")
          : (this.cardtextHeight = "auto");
      } else if (window.innerWidth < 726 && window.innerWidth >= 651) {
        this.mini
          ? (this.cardtextHeight = "250px")
          : (this.cardtextHeight = "auto");
      } else if (window.innerWidth < 651 && window.innerWidth >= 636) {
        this.mini
          ? (this.cardtextHeight = "270px")
          : (this.cardtextHeight = "auto");
      } else if (window.innerWidth < 636 && window.innerWidth >= 606) {
        this.mini
          ? (this.cardtextHeight = "295px")
          : (this.cardtextHeight = "auto");
      } else {
        this.cardtextHeight = "auto";
      }
    },
    moduleDetails(id) {
      this.$router.push("/modules/" + id);
    },
    async searchQuery() {
      await store
        .dispatch(
          FETCH_MODULES,
          "?lang_ids=" +
            this.lang_ids +
            "&is_subscribed=" +
            this.subscriptions +
            "&course_ids=" +
            this.coursesData +
            "&search=" +
            this.search
        )
        .then((resp) => {
          if (resp.success) {
            store.commit(SET_LOADING, false);
          }
        });
    },
    addFilter(filterdatas) {
      if (
        filterdatas.hasOwnProperty("lang_name") &&
        this.lang_ids.indexOf(filterdatas.lang_id) == -1
      ) {
        this.lang_ids.push(filterdatas.lang_id);
        this.send();
      } else if (
        filterdatas.hasOwnProperty("course_name") &&
        this.coursesData.indexOf(filterdatas.course_id) == -1
      ) {
        this.coursesData.push(filterdatas.course_id);
        this.send();
      }
    },
    removeFilter(filterdata) {
      this.selectedFilters = this.selectedFilters.filter(
        (filters) => JSON.stringify(filters) !== JSON.stringify(filterdata)
      );
      if (filterdata.hasOwnProperty("modelvalue"))
        this.subscriptions = this.subscriptions.filter(
          (subscriptionsdata) => subscriptionsdata !== filterdata.value
        );
      else if (filterdata.hasOwnProperty("lang_name"))
        this.lang_ids = this.lang_ids.filter(
          (languagesids) => languagesids !== filterdata.lang_id
        );
      else if (filterdata.hasOwnProperty("course_name"))
        this.coursesData = this.coursesData.filter(
          (courseids) => courseids !== filterdata.course_id
        );
      this.send();
    },
    async send() {
      let selectedSubscription = this.subscriptionData.filter((subdata) =>
        this.subscriptions.includes(subdata.value)
      );
      let selectedLanguage = this.languages.filter((langdata) =>
        this.lang_ids.includes(langdata.lang_id)
      );
      let selectedCourse = this.courses.filter((coursesdata) =>
        this.coursesData.includes(coursesdata.course_id)
      );
      this.selectedFilters = selectedLanguage.concat(
        selectedCourse.concat(selectedSubscription)
      );

      await store
        .dispatch(
          FETCH_MODULES,
          "?lang_ids=" +
            this.lang_ids +
            "&is_subscribed=" +
            this.subscriptions +
            "&course_ids=" +
            this.coursesData +
            "&search=" +
            this.search
        )
        .then((resp) => {
          if (resp.success) {
            store.commit(SET_LOADING, false);
          }
        });
    },
  },
};
</script>
<style scoped>
.course-title {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-box-align: start !important;
  -webkit-line-clamp: 2;
  overflow: hidden;
  height: 4em;
  line-height: 1.5;
  text-overflow: ellipsis;
}
</style>
